export default __webpack_public_path__ + "static/media/zip.6f4a6c7f.svg";